<template>
  <div class="login">
    <h1>Login</h1>
    <p class="login-message"><transition name="fade"><span v-if="loginMessage">{{ loginMessage }}</span></transition>&nbsp;</p>
    <form ref="loginbox" class="group" :class="{shake: isShaking}" @submit.stop="false">
      <input ref="un" v-model="un" type="text" placeholder="Username" autofocus autocomplete="username" @keyup="detectReturn">
      <input ref="pw" v-model="pw" type="password" placeholder="Password" autocomplete="current-password" @keyup="detectReturn">
      <loading-spinner v-if="loading" />
      <button class="round go" @click="doLogin">
        →
      </button>
    </form>
    
    <article class="iforgot">
      <a href="#">Forgot password</a>
    </article>
  </div>
</template>

<style lang="scss">
  @keyframes shake {
    10%, 90% {
      transform: translate3d(-2px, 0, 0);
    }
  
    20%, 80% {
      transform: translate3d(4px, 0, 0);
    }

    30%, 50%, 70% {
      transform: translate3d(-8px, 0, 0);
    }

    40%, 60% {
      transform: translate3d(8px, 0, 0);
    }
  }

  .login {
    
    // Special case: we hide everything else in the background.
    position: fixed;
    width: 100%;
    height: 100% !important;
    z-index: 10000;
    background: var(--popover-abgcolor);
    backdrop-filter: blur(10px);
//    background: red;
    
    h1 { margin-top: 3rem; text-align: center; }
    .login-message { 
      text-align: center; 
      >span { 
        
      }
    }
    .group {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
  
      input { 
        display: block; 
        width: 80%;
        border-radius: 8px;
        line-height: 2em;
        font-size: 1.25em;
        -webkit-appearance: none;
        background-color: var(--input-bgcolor);
        color: var(--text-color);
        border: 1px solid rgba(0,0,0,0.8);
        padding: 0.5em 1em;
        max-width: 400px;
      }
  
      // Override chrome's insane autofill takeover
      input:-webkit-autofill,
      input:-webkit-autofill:focus,
      input:-internal-autofill-selected {
        transition: background-color 0s 600000s, color 0s 600000s !important;
        font-size: 1.25em !important;
      }
      
      input:-internal-autofill-selected:focus {
        box-shadow: 0 0 10px rgb(255 255 255 / 0.3) inset;
      }
  
      input:first-child {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }

      input+input {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      }
      
      input:focus-visible { 
        border: 1px solid var(--text-dim1-color);
        outline: none;
      }
      
      .spinner {
        position: absolute;
        bottom: -1em;
      }
  
      button.go {
        margin-top: 1em;
        text-overflow: clip;
      }
  
      &.shake > input {
        animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
        transform: translate3d(0, 0, 0);
        backface-visibility: hidden;
        perspective: 1000px;
      }
    }
    
    .iforgot {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
//      height: stretch;
      text-align: center;
      margin: 1rem;
      
      a { color: var(--text-color);}
    }
  }
</style>

<script>
import eventbus from '@/eventbus.js'
import settings from '@/lib/settings.js'
export default {
  data() {
    return {
      loading: false,
      isShaking: false,
      loginMessage: '',
      un: '',
      pw: '',
    }
  },
  
  methods: {
    detectReturn(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        e.target.blur();
        this.doLogin();
      }
    },
    
    doLogin(e) {
      e?.preventDefault();
      e?.target.blur();
      
      console.log("Doing Sign In");
      this.loginMessage = ''
      this.loading = true;
      settings.token = undefined; // clear this so we don't try to send a token to get a token.
      
      // this.$store.dispatch('fetchToken', {un: this.un, pw: this.pw})
      //   .then(r => this.loginDidSucceed())
      //   .catch(err => this.loginDidFail(err))
      this.sharedStore.fetchToken(this.un, this.pw)
        .then(r => this.loginDidSucceed())
        .catch(err => this.loginDidFail(err))
    },

    shakeLogin() {
      console.log("will shake login");
      this.isShaking = true
      const elm = this.$refs.loginbox;
      const stopShaking = (e) => { 
        this.isShaking = false;  
        elm.removeEventListener("webkitAnimationEnd", stopShaking);
        elm.removeEventListener("animationend", stopShaking);
        elm.removeEventListener("oanimationend", stopShaking);
      };
      elm.addEventListener("webkitAnimationEnd", stopShaking);
      elm.addEventListener("animationend", stopShaking);
      elm.addEventListener("oanimationend", stopShaking);
    },
    
    loginDidFail(err) {
      this.loading = false;

      this.$refs.pw.focus(); 
      this.$refs.pw.select()

      console.debug("LoginDidFail: ", err);
      if (err?.response?.status === 403) {
        this.loginMessage = 'Incorrect username/password'
      } 
      else
      if (err?.message) {
        this.loginMessage = err.message
      }
      
      this.shakeLogin();
    },
    
    loginDidSucceed() {
      console.debug("loginDidSucceed");
      const p = this.$route.query.t || '/';
      const r = this.$router;
      console.log("redirecting: ", p);
      r.replace({path: p}).then(() => {
        console.debug("emit loginViewDidSucceed");
        eventbus.emit('loginViewDidSucceed', {
          newPath: p
        });
      });
    }
  }
}
</script>